export default __webpack_public_path__ + "static/nvm-bf9d2b9936eb3782c855b8a293d7b81f.png";